import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { HistoryDetailComponent } from './components/history-detail/history-detail.component';
interface Change {
  old: string;
  new: string;
}
@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})

export class HistoryComponent {
  @ViewChild('historyDetail_Ref') historyDetail_Ref: HistoryDetailComponent;
  @Input() moduleName: string = '';
  @Input() historyData: any;

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent) {
    this.hide();
  }

  visibility: boolean = false;
  events: any;
  constructor() {}

  ngOnChanges() {
    this.events = this.historyData;
  }

  show() {
    this.visibility = true;

    setTimeout(() => {
      const maskElement = document.querySelector('.p-dialog-mask');
      
      if (maskElement) {
        maskElement.addEventListener('click', () => {
          this.hide();
        });
      } else {
        //console.error('p-dialog-mask element not found');
      }
    }, 100);
  }

  viewAllDialog() {
    this.historyDetail_Ref.show();
  }

  hide() {
    this.visibility = false;
  }
  getChangeValues(change: any) {
    return change.value as { new: string, old: string };
  }

  hasUpdatedEvent(): boolean {
    return this.events.some((item:any) => item.event === 'updated');
  }
}
